import React, { useState, useEffect } from "react";
import { LoadToBeStoredItems } from "../../../../domain/usecases/load-to-be-stored-items";
import { storeActions, StoreDispatch, storeItemStore } from "./store";
import { useDispatch } from "react-redux";
import { LoadProductListByManyCodes } from "../../../../domain/usecases/load-product-list-by-many-codes";
import { Outlet, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useErrorHandler } from "../../hooks";

type Props = {
  loadToBeStoredItems: LoadToBeStoredItems;
  loadProductListByManyCodes: LoadProductListByManyCodes;
};

export const Store: React.FC<Props> = ({
  loadToBeStoredItems,
  loadProductListByManyCodes,
}) => {
  const dispatch = useDispatch<StoreDispatch>();
  const location = useLocation();
  const navigate = useNavigate();
  const handleError = useErrorHandler((error) => {
    alert("Erro ao carregar itens");
  });

  useEffect(() => {
    async function fetch() {
      const warehouseString = localStorage.getItem("currentWarehouse");
      const warehouse = warehouseString
        ? (JSON.parse(warehouseString) as {
            id: number;
            name: string;
          } | null)
        : undefined;
      try {
        const items = await loadToBeStoredItems.load(warehouse!.id);

        if (items.length === 0) {
          alert("Não há itens a serem guardados");
          navigate("/mobile/tasks");
          return;
        }

        let codes: string[] = [];

        items.map((item) => {
          codes.push(item.code);
        });

        const productList = await loadProductListByManyCodes.load(codes);

        items.map((item) => {
          const product = productList.find(
            (product) => product.eanCode === item.code
          );
          if (!product) return;
          item.description = product.description;
          item.packageAmount = product.packageAmount;
          item.supplier = product.supplier;
          item.batchControl = !!product.batchControl;
          item.insertBatchLater = false;
        });

        await dispatch(storeActions.saveItems({ items }));
      } catch (error) {
        handleError(error as Error);
      }
    }
    fetch();
  }, [location.pathname]);

  return (
    <>
      <Outlet />
    </>
  );
};
